// Where a demo visitor goes next. The marketing page is the source of truth
// for pricing, and the contact form lives on the home page.
export const FORGE_URL = 'https://www.nlc.consulting/forge';
export const PRICING_URL = 'https://www.nlc.consulting/forge#pricing';
export const CONTACT_URL = 'https://www.nlc.consulting/#contact';
export const PHONE_HREF = 'tel:+18565224261';
export const PHONE_LABEL = '(856) 522-4261';
